
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.952","height":"26.87"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.586 26.867H0L1.807.001h18.242z","fill":"#145629"}}),_c('path',{attrs:{"d":"M11.803 3.904h12.254l.9 22.969H5.53l.691-17.721z","fill":"#248332"}}),_c('path',{attrs:{"d":"M11.731 3.908v5.207H6.197z","fill":"#72a56b"}}),_c('path',{attrs:{"d":"M11.504 18.234l-1.38 3.759a.328.328 0 00.442.412l3.658-1.641a.327.327 0 00.083-.071l6.945-7.448-2.738-2.553-6.945 7.448a.368.368 0 00-.065.094z","fill":"#fff"}})])
          )
        }
      }
    